/* eslint-disable jsx-a11y/no-autofocus,import/no-unresolved */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/display-name,react/jsx-props-no-spreading */
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import BigNumber from 'bignumber.js';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useMutation, useQuery } from 'react-query';
import { isBrowser, isMobile } from 'react-device-detect';
import Badge from '../../../../components/Badge';
import { SendCryptoScreensFlow, AMOUNT_INPUT_MAX_LENGTH, SEND_MODES } from '../../constants';
import { formatNumber, formatDecimalNumber } from '../../../../utilities/formatHelpers';
import { currencies, exchange } from '../../../../utilities/constants';
import { useRateDetails } from '../../../../utilities/sharedHooks/rates';
import ModalBodyLayout from '../../../shared/ModalBodyLayout';
import { TRANSACTION_CALCULATE_FEES } from '../../mutations';
import { showAlert } from '../../../../utilities/notifications';
import FocusableInputArea from '../../partials/FocusableInputArea';
import CurrencyIcon from '../../../../components/CurrencyIcon';
import { validateNumbers } from '../../../../utilities/formValidation';
import { WalletsTypes } from '../../../Card/constants';
import {
  SETTINGS_SUPPORTED_CURRENCIES_QUERY_KEY,
  USER_REGION_SETTINGS_QUERY_KEY,
} from '../../../../utilities/sharedQueries';
import useRiskTierSettings from '../../../../utilities/sharedHooks/useRiskTierSettings';
import { useLedgerAccountById } from '../../../../utilities/sharedHooks/ledgerSDKHooks';
import { useLedgerFilteredCurrencies } from '../../../../utilities/sharedHooks/ledgerWallets';
import { useSetting } from '../../../../utilities/sharedHooks/settings';
import Alert from '../../../../components/Alert';
import ChecklistOption from '../../../../components/Checklist';

import { GET_LAST_USED_WHITELIST_ADDRESS } from '../../queries';
import { tagColors, tags } from './constants';
import { GenericLoading } from '../../../../components/Placeholders';
import { maskCoinAddress } from '../../../../utilities/helpers';

const SendCryptoWhitelist = ({ wallet, ledgerAccount, fiatCurrencyCode, openScreen, options }) => {
  const defundWalletId =
    wallet?.hard_wallet_ids?.length > 0 ? wallet?.hard_wallet_ids[0].hard_wallet_id : null;
  const [defundWallet] = useLedgerAccountById(defundWalletId);

  if (defundWallet && ledgerAccount) {
    ledgerAccount.id = defundWallet.id;
  }

  const { data: supportedCurrencies } = useLedgerFilteredCurrencies([
    SETTINGS_SUPPORTED_CURRENCIES_QUERY_KEY,
  ]);

  const { t: translate } = useTranslation();

  const { data: userRegionSettings } = useQuery(USER_REGION_SETTINGS_QUERY_KEY);
  const [selectedWalletAddress, setSelectedWalletAddress] = useState({});

  const { isLoading: isWhitelistLoading, refetch: loadLastUsedWhitelistedAddress } = useQuery(
    [GET_LAST_USED_WHITELIST_ADDRESS, { coin_id: wallet?.coin_id }],
    {
      onSettled: (data) => {
        if (!options?.selectedWallet && data && data.length) {
          setSelectedWalletAddress(data[0]);
        }
      },
    },
    {
      enabled: false,
    }
  );

  useEffect(() => {
    loadLastUsedWhitelistedAddress();
  }, [options?.selectedWallet]);

  useEffect(() => {
    loadLastUsedWhitelistedAddress();
  }, []);

  useEffect(() => {
    if (options?.selectedWallet) {
      setSelectedWalletAddress(options?.selectedWallet);
    }
  }, [options?.selectedWallet]);

  const { riskAssessment } = useRiskTierSettings();

  const isTextBitAllowed = useMemo(() => {
    if (userRegionSettings && riskAssessment.settings) {
      return (
        userRegionSettings.can_send_by_textbit && riskAssessment.userRisk.send_crypto_via_textbit
      );
    }
    return userRegionSettings?.can_send_by_textbit;
  }, [userRegionSettings, riskAssessment]);

  // # this const added to disable and hide send by adress and phone number temporary, ticket number is DV-2781
  const [isAllowToSendByAddressAndPhoneNumber] = useSetting(
    'app_features',
    'allow_send_withdrawal_by_address_or_phone_number'
  );

  const [isManualAmount, setIsManualAmount] = useState(false);
  const currency = currencies[wallet?.coin];
  const { rate } = useRateDetails(wallet?.coin, fiatCurrencyCode, true);
  const walletBalance = formatNumber(
    wallet?.available_balance * currency.conversion,
    currency.decimal
  );
  const currencyBalanceLabel = `${walletBalance} ${currency.icon}`;
  const [fiatInputWidth, setFiatInputWidth] = useState(0);
  const [cryptoInputWidth, setCryptoInputWidth] = useState(0);
  const [isSwap, setIsSwap] = useState(false);

  const availableCryptoValues = useMemo(() => [50, 100, 200], []);

  const [fiatAmount, setFiatAmount] = useState('0');
  const [cryptoAmount, setCryptoAmount] = useState('0');
  const [fiatFormattedAmount, setFiatFormattedAmount] = useState('0');
  const [cryptoFormattedAmount, setCryptoFormattedAmount] = useState('0');
  const fiatInputSpan = useRef();
  const cryptoInputSpan = useRef();

  const openConfirmationScreen = (fees) => {
    const recipient = selectedWalletAddress?.wallet_address;
    const memo = selectedWalletAddress?.memo;
    const isLedgerAddress = !!selectedWalletAddress.wallet_id;
    openScreen(SendCryptoScreensFlow.CONFIRM_TRANSACTION, {
      recipient,
      source: wallet?.address,
      coin: wallet?.coin,
      coin_id: wallet?.coin_id,
      fees,
      amount: cryptoAmount?.toString(),
      isLedgerAddress,
      wallet,
      ledgerAccountId: selectedWalletAddress.wallet_id,
      isWhitelistAddress: true,
      walletBalance,
      memo,
    });
  };

  const isContinueDisabled = useMemo(() => {
    if (cryptoAmount) {
      const recipient = selectedWalletAddress.wallet_address;

      return (
        parseFloat(walletBalance) <= 0 ||
        parseFloat(cryptoAmount) <= 0 ||
        parseFloat(cryptoAmount) > parseFloat(walletBalance) ||
        !recipient
      );
    }

    return true;
  }, [walletBalance, cryptoAmount, selectedWalletAddress]);

  const { isLoading: isLoadingFees, mutate: calculateTransactionFees } = useMutation(
    TRANSACTION_CALCULATE_FEES,
    {
      onSettled(data, error) {
        if (error) {
          if (cryptoAmount > 0) {
            showAlert({ message: error.message, type: 'danger' });
          }
        } else {
          openConfirmationScreen(data);
        }
      },
    }
  );

  const handleChangeFiatAmount = (e) => {
    if (!e.target.value.length) {
      setFiatFormattedAmount(e.target.value);
      setCryptoFormattedAmount(e.target.value);
    }
    const { value: amount, min } = e.target;
    const { decimalAmount, formattedAmount } = formatDecimalNumber(amount, min);

    if (!validateNumbers(decimalAmount, WalletsTypes.FIAT) || !decimalAmount || !formattedAmount) {
      setCryptoAmount(0);
      setFiatAmount(0);
      setCryptoFormattedAmount(0);
      setFiatFormattedAmount(0);
      return;
    }
    setFiatAmount(decimalAmount);
    const calcCrypto = formatNumber(decimalAmount / rate, currency.decimal);
    setCryptoAmount(calcCrypto);
    const formattedCalcCrypto = formatDecimalNumber(calcCrypto);
    setCryptoFormattedAmount(formattedCalcCrypto.formattedAmount);
    setFiatFormattedAmount(formattedAmount);
  };

  const handleChangeCryptoAmount = (e) => {
    if (!e.target.value.length) {
      setFiatFormattedAmount(e.target.value);
      setCryptoFormattedAmount(e.target.value);
    }
    const { value: amount, min } = e.target;
    const { decimalAmount, formattedAmount } = formatDecimalNumber(amount, min);

    if (
      !validateNumbers(decimalAmount, WalletsTypes.CRYPTO) ||
      !decimalAmount ||
      !formattedAmount
    ) {
      setCryptoAmount(0);
      setFiatAmount(0);
      setCryptoFormattedAmount(0);
      setFiatFormattedAmount(0);
      return;
    }
    setCryptoAmount(decimalAmount);
    const calcFiat = formatNumber(decimalAmount * rate, exchange.FIAT_VALUE);
    setFiatAmount(calcFiat);
    const formattedFiatCalc = formatDecimalNumber(calcFiat);
    setFiatFormattedAmount(formattedFiatCalc.formattedAmount);
    setCryptoFormattedAmount(formattedAmount);
  };

  const handleFocus = (e) => {
    if (!e.target) return;
    if (e.target.closest('.amount-input')) {
      e.target.closest('.amount-input').classList.add('active');
    }
  };

  const handleBlurAmount = (e) => {
    if (!e.target) return;
    if (e.target.closest('.amount-input')) {
      e.target.closest('.amount-input').classList.remove('active');
    }
    const decimalNumber = e?.target?.value || '0';
    if (decimalNumber) {
      setCryptoFormattedAmount(decimalNumber.valueWithDecimal);
      // to avoid having empty input, fix length to 1 if text length is less then 1
      setCryptoInputWidth(decimalNumber.length > 1 ? decimalNumber.length : 1);
    }
  };

  useEffect(() => {
    const charactersLength =
      fiatInputSpan.current.value.length > 1 ? fiatInputSpan.current.value.length : 1;
    // to avoid having empty input, fix length to 1 if text length is less then 1
    setFiatInputWidth(charactersLength);
  }, [fiatAmount, isSwap]);

  useEffect(() => {
    if (cryptoInputSpan.current) {
      const closestContainer = cryptoInputSpan.current.closest('.d-flex');
      const closestContainerParent = closestContainer.closest('.modal-body');
      const charactersLength =
        cryptoInputSpan.current.value.length > 1 ? cryptoInputSpan.current.value.length + 1 : 2;
      // to avoid having empty input, fix length to 2 if text length is less then 1
      if (closestContainerParent.offsetWidth < closestContainer.scrollWidth) {
        closestContainer.style.fontSize = '1.5rem';
      } else if (cryptoInputSpan.current.value.length < AMOUNT_INPUT_MAX_LENGTH) {
        // resize input font size to 2.125rem when char length is less then AMOUNT_INPUT_MAX_LENGTH
        closestContainer.style.fontSize = '2.125rem';
      }
      setCryptoInputWidth(charactersLength);
    }
  }, [cryptoFormattedAmount, isSwap]);

  const onSubmit = (e) => {
    e.preventDefault();
    if (parseFloat(cryptoAmount) <= 0) {
      cryptoInputSpan.current.focus();
      return false;
    }
    const bigNumberWalletBalance = walletBalance ? BigNumber(walletBalance) : 0;
    const BigNumberCryptoAmount = BigNumber(cryptoAmount);
    if (BigNumberCryptoAmount.gt(bigNumberWalletBalance)) {
      showAlert({
        message: translate('error_no_enough_available_funds'),
        type: 'danger',
      });
      return false;
    }
    calculateTransactionFees({
      source: wallet?.address,
      destination: selectedWalletAddress.wallet_address,
      amount: cryptoAmount?.toString(),
      mode: SEND_MODES.ADDRESS,
      coin: wallet?.coin,
      currencyId: wallet?.coin_id,
    });
    return true;
  };

  let selectedWalletTag;

  if (options?.selectedWallet) {
    if (options?.selectedWallet?.wallet_id) {
      selectedWalletTag = tags.LEDGER;
    } else {
      selectedWalletTag = tags.EXTERNAL;
    }
  } else if (selectedWalletAddress) {
    if (selectedWalletAddress.wallet_id) {
      selectedWalletTag = tags.LEDGER;
    } else {
      selectedWalletTag = tags.EXTERNAL;
    }
  }

  const renderTitle = () => (
    <div
      className={`w-100 ${isBrowser ? 'd-flex align-items-center justify-content-between' : ''} `}>
      <div>
        <CurrencyIcon
          currencyCode={wallet?.coin}
          style={{
            width: '1.5rem',
            height: '1.5rem',
            ...(wallet?.coin?.toUpperCase() === currencies.XRP.icon
              ? {
                  backgroundColor: 'white',
                  padding: '1px',
                  borderRadius: '20px',
                }
              : {}),
          }}
        />
        <b className="text-f5 text-dark ms-2">{`${translate(
          'send_label'
        )} ${wallet?.coin.toUpperCase()}`}</b>
      </div>
      <p className={`text-shadow text-f6 ${isMobile ? 'mt-4' : ''}`}>
        {translate('available_balance_label')}:{' '}
        <span className="text-dark">{currencyBalanceLabel}</span>
      </p>
    </div>
  );

  const renderFooter = () => (
    <button
      loading={isLoadingFees ? 'true' : 'false'}
      className="btn py-3 btn-primary"
      type="submit"
      form="send-amount-modal"
      disabled={isContinueDisabled}
      onClick={onSubmit}>
      {translate('confirm_continue_btn_title')}
    </button>
  );

  const addWhitelistAddress = useCallback(() => {
    if (
      (wallet &&
        supportedCurrencies &&
        supportedCurrencies[wallet?.coin] &&
        !supportedCurrencies[wallet?.coin]?.secure_funding_enabled) ||
      !ledgerAccount
    ) {
      openScreen(SendCryptoScreensFlow.WHITELIST_ADD_EXTERNAL, {
        prevScreen: SendCryptoScreensFlow.SEND_CRYPTO,
      });
    } else {
      openScreen(SendCryptoScreensFlow.WHITELIST_ADDRESS_TYPE, {
        prevScreen: SendCryptoScreensFlow.SEND_CRYPTO,
      });
    }
  }, [supportedCurrencies, ledgerAccount]);

  return (
    <ModalBodyLayout
      withBack={false}
      renderFooter={renderFooter}
      renderTitle={renderTitle}
      title={null}
      isScrollable={false}>
      <div className="d-flex flex-fill flex-column justify-content-center align-content-center h-100">
        <form onSubmit={onSubmit} id="send-amount-modal">
          <div className="text-shadow text-f6">{translate('deposit_wallet_enter_amount')}</div>

          <FocusableInputArea className="mb-1">
            <input
              required
              min="0"
              type="text"
              className="form-control bg-transparent p-0 text-center border-0"
              value={isSwap ? cryptoFormattedAmount : fiatFormattedAmount}
              style={{
                fontSize: 'inherit',
                width: `${(isSwap ? cryptoInputWidth : fiatInputWidth) + 1}ch`,
              }}
              ref={isSwap ? cryptoInputSpan : fiatInputSpan}
              onFocus={handleFocus}
              disabled
              onChange={(e) => {
                if (isSwap) {
                  handleChangeCryptoAmount(e);
                } else {
                  handleChangeFiatAmount(e);
                }
                setIsManualAmount(true);
              }}
              placeholder="0"
            />
            <span style={{ fontSize: 'inherit', pointerEvents: 'none' }} className="text-f5">
              {isSwap ? wallet?.coin.toUpperCase() : fiatCurrencyCode}
            </span>
            <span
              role="button"
              className="mb-1"
              tabIndex="0"
              onKeyPress={() => setIsSwap((a) => !a)}
              onClick={() => setIsSwap((a) => !a)}>
              <img src="./assets/images/switch.svg" className="ms-2" alt="switch" />
            </span>
          </FocusableInputArea>

          <FocusableInputArea className="h1 amount-input">
            <input
              required
              autoFocus
              min="0"
              type="text"
              className="form-control bg-transparent text-bold p-0 text-center border-0"
              value={isSwap ? fiatFormattedAmount : cryptoFormattedAmount}
              style={{
                fontSize: 'inherit',
                width: `${(isSwap ? fiatInputWidth : cryptoInputWidth) + 1}ch`,
                color: 'inherit',
                height: 'inherit',
              }}
              ref={isSwap ? fiatInputSpan : cryptoInputSpan}
              onChange={(e) => {
                if (isSwap) {
                  handleChangeFiatAmount(e);
                } else {
                  handleChangeCryptoAmount(e);
                }
                setIsManualAmount(true);
              }}
              onFocus={handleFocus}
              onBlur={!isSwap ? handleBlurAmount : undefined}
              placeholder="0  "
            />
            <b
              style={{
                fontSize: 'inherit',
                pointerEvents: 'none',
                color: 'inherit',
              }}>
              {isSwap ? fiatCurrencyCode : wallet?.coin.toUpperCase()}
            </b>
          </FocusableInputArea>

          <div className="d-flex justify-content-between mt-3">
            {availableCryptoValues.map((presetAmount) => (
              <Badge
                notifyRemoveActive={isManualAmount}
                key={presetAmount}
                content={`${presetAmount} ${fiatCurrencyCode}`}
                onClick={() => {
                  setIsManualAmount(false);
                  handleChangeFiatAmount({ target: { value: `${presetAmount}` } });
                }}
                className="py-1 px-3 text-white rounded-4 text-f5 cursor-pointer"
              />
            ))}
            <Badge
              notifyRemoveActive={isManualAmount}
              onClick={() => {
                setIsManualAmount(false);
                handleChangeCryptoAmount({ target: { value: `${walletBalance}` } });
              }}
              content={`${translate('max_button_label').toUpperCase()}`}
              className="py-1 px-4 text-white rounded-4 text-f5 cursor-pointer"
            />
          </div>

          {isTextBitAllowed && (isAllowToSendByAddressAndPhoneNumber || wallet?.coin === 'bxx') && (
            <div className="col-12 rounded pb-1 pt-2 mt-4">
              <div className="btn-light w-100 d-flex flex-row-center bg-lighter border border-shadow rounded-4">
                <button
                  type="button"
                  style={{ borderRadius: '0.75rem' }}
                  className="toggle-item text-white p-1 btn toggle-item-modal w-50 toggle-item active"
                  onClick={() => {}}>
                  {translate('address_label')}
                </button>
              </div>
            </div>
          )}

          {!isWhitelistLoading && !selectedWalletAddress.wallet_address ? (
            <div className="mt-4">
              <Alert type="info" isClickable icon="info" onClick={addWhitelistAddress}>
                {translate('whitelist_message_action_empty')}
              </Alert>
            </div>
          ) : (
            <div className="mt-4">
              {selectedWalletAddress?.wallet_address ? (
                <>
                  <div className="mb-4">
                    <ChecklistOption
                      key={selectedWalletAddress.id}
                      title={selectedWalletAddress.name || selectedWalletAddress.coin}
                      subTitle={maskCoinAddress(selectedWalletAddress.wallet_address)}
                      value={selectedWalletAddress}
                      withCheckbox={false}
                      tag={selectedWalletTag}
                      tagColor={tagColors[selectedWalletTag]}
                      className="mb-2"
                      isChecked
                    />
                  </div>
                  <Alert
                    type="info"
                    isClickable
                    icon="info"
                    onClick={() => openScreen(SendCryptoScreensFlow.WHITELIST_SELECT_ADDRESS)}>
                    {translate('whitelist_message_action')}
                  </Alert>
                </>
              ) : (
                <GenericLoading isFullScreen={false} />
              )}
            </div>
          )}
        </form>
      </div>
    </ModalBodyLayout>
  );
};

export default SendCryptoWhitelist;

SendCryptoWhitelist.propTypes = {
  wallet: PropTypes.object.isRequired,
  ledgerAccount: PropTypes.object,
  fiatCurrencyCode: PropTypes.string.isRequired,
  openScreen: PropTypes.func.isRequired,
  options: PropTypes.object,
};
SendCryptoWhitelist.defaultProps = {
  ledgerAccount: null,
  options: null,
};
